import {toggle_loader, disable_loader} from '../../theme/_loader';
import {toggle_search_modal} from '../../theme/tyres/_search';
import Cookies from 'js-cookie';
import swal from 'sweetalert';

export default function(endpoint, registration, slider) {

	return new Promise(function (resolve, reject) {

		//enable the loader to prevent user interaction
		toggle_loader();

		const xhr = new XMLHttpRequest();
		xhr.addEventListener("readystatechange", function () {
			if (this.readyState === this.DONE) {

				try {

					let response = JSON.parse(this.responseText);

					if(response) {

						//save this as a cookie
						Cookies.set('bt_lookup', JSON.stringify(response), {expires: 1});

						//populate preview fields with info about the vehicle
						Object.entries({
							'reg-preview-registration': response.query,
							'reg-preview-body': (response.make ? response.make : '') + ((response.make && response.model ? ' ' : '')) + (response.model ? response.model : ''),
							'reg-preview-colour' : (response.colour ? '(' + response.colour + ')' : ''),
						}).forEach(entry => {
							const [id, value] = entry;
							let elem = document.getElementById(id);

							if(elem) {
								elem.innerHTML = value;
							}
						});


						let confirmation_container = document.getElementById('reg-confirm-tyre-size');
						let size_markup = `<div class="ff-el-form-check !rounded-2xl 500px:!rounded-full ff-el-form-check- before:!top-0 before:!translate-y-0 500px:before:!top-1/2 before:!mt-6 500px:before:!mt-0 500px:before:!-translate-y-1/2">
							<label class="ff-el-form-check-label w-full relative" for="tyre-{id}">
								<input type="radio" id="tyre-{id}" name="front" class="tyre-lookup-choice ff-el-form-check-input ff-el-form-check-checkbox" value="{width_front},{profile_front},{rim_front},{speed_front}" data-rear="{width_rear},{profile_rear},{rim_rear},{speed_rear}" required>
								<span class="tyre-search-checkbox !block 500px:!flex">
									<span class="tyre-title flex-1 !mr-0 mb-2 block 500px:mb-0">
										Front:
										<strong class="block">{title_front}</strong>
									</span>

									<span class="tyre-title block flex-1 !mr-0">
										Rear:
										<strong class="block">{title_rear}</strong>
									</span>

									<button type="button" class="view-results w-full 500px:w-auto block !pointer-events-auto bg-primary rounded-full text-center max-h-0 500px:max-w-0 500px:!max-h-full 500px:!mt-0 overflow-hidden whitespace-nowrap transition-all duration-300 hover:opacity-50">
										<span class="block py-3 500px:py-0 px-4 font-bold tyre-title !mr-0 pointer-events-none">
											View Tyres
										</span>
									</button>
								</span>
							</label>
						</div>`;

						if(confirmation_container) {

							//clear the existing HTML
							confirmation_container.innerHTML = '';

							for(let i = 0; i < response.tyres_sizes.length; i++) {
								let tyre_data = response.tyres_sizes[i];

								let tyre = size_markup;

								['front', 'rear'].forEach(axle => {

									tyre = tyre.replace('{id}', (i + '-xxx'));
									tyre = tyre.replace('{profile_' + axle + '}', tyre_data[axle].details.profile);
									tyre = tyre.replace('{rim_' + axle + '}', tyre_data[axle].details.rim);
									tyre = tyre.replace('{speed_' + axle + '}', tyre_data[axle].details.speed);
									tyre = tyre.replace('{width_' + axle + '}', tyre_data[axle].details.width);

									//if this is the rear axle and it's the same as the front
									if(axle == 'rear' && tyre_data[axle].title == tyre_data['front'].title) {

										//indicate it's the same
										tyre = tyre.replace('{title_' + axle + '}', 'Same as front');

									} else { //otherwise...

										//specify the difference
										tyre = tyre.replace('{title_' + axle + '}', tyre_data[axle].title);
									}

								});

								//append the input
								confirmation_container.innerHTML += tyre;
							}
						}

						//when we're finally done, slide to the next slide
						slider.slideTo(3);
					}

					disable_loader();
					resolve(true);
				} catch(error) {

                    //set our default title
                    let title = 'Whoops, something went wrong';

                    //if we have a heading in the toasts object
                    if(tyres_ajax_object.toasts.tyre_search.fail.heading) {

                        //strip any HTML tags
                        title = (tyres_ajax_object.toasts.tyre_search.fail.heading).replace(/(<([^>]+)>)/gi, "");
                    }

                    //sets our default text
                    let text = 'We were unable to perform a search based on the details provided. Please review and try again.';

                    //if we have a content in the toasts object
                    if(tyres_ajax_object.toasts.tyre_search.fail.content) {

                        //strip any HTML tags
                        text = (tyres_ajax_object.toasts.tyre_search.fail.content).replace(/(<([^>]+)>)/gi, "");
                    }

                    //find and replace the [REG] shortcode
                    title = title.replace('[REG]', registration.toUpperCase());
                    text = text.replace('[REG]', registration.toUpperCase());

                    //create an error notification
                    swal({
                        title: title,
                        text: text,
                        buttons: {
                            ...{
                                reg: {
                                    text: 'Try again',
                                    value: 'reg'
                                },
                                size: {
                                    text: 'Enter your tyre size',
                                    value: 'size'
                                }
                            },
                            ...(tyres_ajax_object.toasts.tyre_search.fail.whatsapp ? {
                                whatsapp: {
                                    text: 'Message us via WhatsApp',
                                    value: 'whatsapp'
                                }
                            } : {})
                        },
                    }).then((value) => {

                        //get the registration slider
                        const registration_slider = document.getElementById('open-registration').swiper;

                        //check to see if the search modal is open
                        let search_modal_open = document.body.classList.contains('search-modal-open');

                        //switch the value
                        switch (value) {
                            case "reg":

                                //if we have a search modal open
                                if(search_modal_open) {

                                    //slide back to the first slide
                                    registration_slider.slideTo(0);
                                }

                                break;
                            case "size":

                                //if we have a search modal open
                                if(search_modal_open) {

                                    //close the search modal
                                    toggle_search_modal();

                                    //wait...
                                    setTimeout(() => {

                                        //open the tyre size modal
                                        toggle_search_modal('tyre');
                                    }, 300);
                                } else { //otherwise this was the compact CTA

                                    //fetch the quick reg containers
                                    let quick_reg_containers = document.getElementsByClassName('quick-reg-container');

                                    //if we have some quick reg instances
                                    if(quick_reg_containers && quick_reg_containers.length) {

                                        //loop through them
                                        for(let i = 0; i < quick_reg_containers.length; i++) {

                                            //set the view to tyre
                                            quick_reg_containers[i].parentNode.dataset.view = 'tyre';

                                            //if this is the first instance
                                            if(i === 0) {

                                                //scroll to the top of the container
                                                quick_reg_containers[i].scrollIntoView({behavior: 'smooth'});
                                            }
                                        }
                                    }
                                }

                                break;
                            case "whatsapp":

                                //if we have a WhatsApp option, open the WhatsApp link
                                if(tyres_ajax_object.toasts.tyre_search.fail.whatsapp) {

                                    window.open(tyres_ajax_object.toasts.tyre_search.fail.whatsapp, '_blank');
                                }

                                break;
                        }
                    });

					disable_loader();
					resolve(false);
				}
			}
		});

		xhr.open("POST", endpoint);
		xhr.setRequestHeader("Accept", "*/*");
		xhr.setRequestHeader("Content-Type", "application/json");

		xhr.send(JSON.stringify({
			"registration": registration
		}));
	});
};